"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getAllTimesStatsId(ownerId, statName) {
    return `${statName}-${ownerId}`;
}
exports.default = getAllTimesStatsId;
